import * as React from "react";

function IDCell(props) {
    return (
        <td
            {...props}
            className="align-items-center"
            style={{
                touchAction: "none",
            }}
        >
            <span className="d-flex align-items-center">
                <span
                    className="k-icon k-i-reorder"
                    style={{
                        cursor: "move",
                        fontSize: "14px"
                    }}
                    data-drag-handle={true}
                />
                &nbsp;
                {
                    props.dataItem['#']
                }
            </span>
        </td>
    );
};

export default IDCell;